import React from 'react'

function SongTime() {
  
  return (
    <div id={`song-time`}>0:00 / 0:00</div>
  )
}

export default SongTime